// Phase 3 — first downgraded Angular component. Replaces the AngularJS `mySwitch`
// element directive (deleted). Standalone (v21 default); rendered back into AngularJS
// templates via downgradeComponent (see downgrades.ts). Display-only: the host's
// `ng-click` (still AngularJS) toggles the bound value; this only reflects it.
import { Component, Input } from '@angular/core';

@Component({ selector: 'my-switch', templateUrl: './my-switch.component.html' })
export class MySwitchComponent {
    @Input() enabled = false;
}
